import { Component } from '@angular/core';
import { MessagingService } from './core/_services/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Service Galaxy Admin';
  message:any;
  constructor(private messagingService: MessagingService,private angularFireMessaging: AngularFireMessaging){
    this.messagingService.getPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage
    this.angularFireMessaging.messages.subscribe(
      (payload: any) => {
      })
      console.log(this.message)
  }

  ngOnInit(){
    this.loadGoogleMaps();
  }

  loadGoogleMaps() {
    const scriptId = 'google-maps-script';
    if (document.getElementById(scriptId)) {
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&v=weekly&loading=async`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  ngOnDestroy() {
    this.messagingService.ngOnDestroy();
  }
}
